import { UserRole } from "./models/enums";
import { SFUserProfile } from "./models/sf-user-profile.model";

export const elevatedUsers: UserRole[] = [
  "Business Development Manager",
  "POD Manager",
  "Capital Markets",
  "Inside Sales Manager",
  "Broker Manager",
  "Lender Finance Manager",
  "Wholesale Manager",
  "Production Coordinator",
  "Operations Analyst",
  "Administrator",
];

export const externalUsers: UserRole[] = ["External"];

export const internalUsers: UserRole[] = [
  "Sales",
  "Broker",
  "Broker Manager",
  "Lender Finance",
  "Lender Finance Manager",
  "Inside Sales",
  "Inside Sales Manager",
  "Capital Markets",
  "Wholesale",
  "Wholesale Manager",
  "POD",
  "POD Manager",
  "Business Development",
  "Business Development Manager",
  "Production Coordinator",
  "Operations Analyst",
  "Sales Assistant",
  "Administrator",
];

export const autoExceptionUsers: UserRole[] = [
  "Inside Sales",
  "Inside Sales Manager",
  "Broker",
  "Broker Manager",
  "Lender Finance",
  "Lender Finance Manager",
  "Business Development",
  "Business Development Manager",
  "POD",
  "POD Manager",
  "Wholesale",
  "Wholesale Manager",
  "Operations Analyst",
];

export const brokerRetailUsers = [
  "Administrator",
  "POD",
  "POD Manager",
  "Business Development",
  "Business Development Manager",
];

export const thirdPartyRetailUsers = [
  "Administrator",
  "Wholesale",
  "Wholesale Manager",
];

export const isElevatedUser = (userRole: UserRole | null) => {
  if (!userRole) {
    return false;
  }

  return elevatedUsers.includes(userRole);
};

export const isInternalUser = (userRole: UserRole | null) => {
  if (!userRole) {
    return false;
  }

  return !externalUsers.includes(userRole);
};

export const isQuoteOwner = (
  quoteOwner: string | undefined,
  activeUser: SFUserProfile | null,
  oktaEmail: string | undefined
) => {
  if (!quoteOwner || !oktaEmail) {
    return false;
  }

  const defaultCheck =
    quoteOwner.toLocaleLowerCase() === oktaEmail.toLocaleLowerCase();

  if (!activeUser?.brokers) {
    return defaultCheck;
  }

  const brokerEmails = activeUser.brokers.map((broker) => {
    if (!broker.username) {
      return "No Email Provided";
    }
    return broker.username.toLocaleLowerCase();
  });

  return defaultCheck || brokerEmails.includes(quoteOwner.toLocaleLowerCase());
};

export const isAutoExceptionUser = (userRole: UserRole | undefined) => {
  if (!userRole) {
    return false;
  }
  return autoExceptionUsers.includes(userRole);
};
